<template>
	<div
		class="relative skeleton overflow-hidden"
		:class="{ 'animation-content bg-neutral-200': hasAnimation, 'bg-neutral-100': !hasAnimation }"
	>
		<slot />
	</div>
</template>
<script setup lang="ts">
	interface Props {
		hasAnimation?: boolean
	}

	withDefaults(defineProps<Props>(), {
		hasAnimation: true,
	})
</script>
<style scoped lang="scss">
	.skeleton {
		&::after {
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			transform: translateX(-100%);
			background-image: linear-gradient(
				90deg,
				rgba(#fff, 0) 0,
				rgba(#fff, 0.2) 20%,
				rgba(#fff, 0.6) 60%,
				rgba(#fff, 0)
			);
			content: '';
		}
	}

	@keyframes skeleton-loading {
		0% {
			background-color: var(--color-neutral-300);
		}
		100% {
			background-color: var(--color-neutral-200);
		}
	}

	@keyframes shimmer {
		100% {
			transform: translateX(100%);
		}
	}

	.animation-content {
		&::after {
			animation: shimmer 3s infinite;
		}
	}
</style>
